var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8781 9.12492C22.3582 8.60481 22.0537 7.90758 22.0257 7.17269C21.9976 6.43779 22.2481 5.71939 22.7269 5.16117C22.7665 5.11474 22.787 5.05506 22.7845 4.9941C22.7819 4.93313 22.7564 4.87538 22.7131 4.83242L19.955 2.07117C19.9094 2.0256 19.8476 2 19.7831 2C19.7186 2 19.6568 2.0256 19.6112 2.07117L15.215 6.46742C15.0528 6.62958 14.9306 6.82731 14.8581 7.04492C14.7859 7.26303 14.6639 7.46132 14.5017 7.62405C14.3395 7.78678 14.1416 7.90948 13.9237 7.98242C13.706 8.05498 13.5081 8.17715 13.3456 8.33929L2.07123 19.6112C2.02566 19.6568 2.00006 19.7186 2.00006 19.783C2.00006 19.8475 2.02566 19.9093 2.07123 19.9549L4.82936 22.713C4.87231 22.7564 4.93006 22.7819 4.99103 22.7844C5.052 22.787 5.11168 22.7664 5.15811 22.7268C5.71621 22.2475 6.43476 21.9967 7.16991 22.0245C7.90506 22.0524 8.60256 22.3569 9.12276 22.8771C9.64296 23.3973 9.94749 24.0948 9.97536 24.83C10.0032 25.5651 9.75242 26.2837 9.27311 26.8418C9.23351 26.8882 9.21292 26.9479 9.21547 27.0089C9.21802 27.0698 9.24352 27.1276 9.28686 27.1705L12.045 29.9287C12.0906 29.9742 12.1524 29.9998 12.2169 29.9998C12.2813 29.9998 12.3431 29.9742 12.3887 29.9287L23.6637 18.6543C23.8259 18.4918 23.948 18.2939 24.0206 18.0762C24.0928 17.8581 24.2149 17.6598 24.377 17.497C24.5392 17.3343 24.7371 17.2116 24.955 17.1387C25.1726 17.0662 25.3703 16.944 25.5325 16.7818L29.9287 12.3855C29.9743 12.34 29.9999 12.2781 29.9999 12.2137C29.9999 12.1492 29.9743 12.0874 29.9287 12.0418L27.1706 9.28367C27.1276 9.24033 27.0699 9.21483 27.0089 9.21228C26.948 9.20973 26.8883 9.23032 26.8419 9.26992C26.2844 9.74953 25.5665 10.001 24.8316 9.97415C24.0967 9.94727 23.399 9.64398 22.8781 9.12492Z",
    stroke: "#089D49",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6563 8.77748L14.6244 7.74561M18.4075 11.5287L17.7194 10.8412M21.1588 14.2806L20.4713 13.5925M24.2544 17.3756L23.2225 16.3437",
    stroke: "#089D49",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.95af4e659885dbc123c14432cf6fbbf4.svg";
export { ForwardRef as ReactComponent };